exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainCol[data-v-5cd7a339] {\n  padding-top: 0 !important;\n}\n.task-volume[data-v-5cd7a339] {\n  padding: 0px 10px 0 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n}\n.task-volume p[data-v-5cd7a339] {\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0;\n  font-size: 18px;\n  margin-right: 20px;\n}\n.task-volume p span[data-v-5cd7a339] {\n  padding: 0;\n}\n.task-volume button[data-v-5cd7a339] {\n  display: inline-block;\n  vertical-align: middle;\n  background-color: white;\n  color: #4fbe2b;\n  padding: 0 25px;\n}", ""]);

// exports
